import { Alert, AlertTitle, Typography } from '@mui/material';

import Icon from './Icon';

interface ErrorAlertProps {
	className?: string;
	error: any;
}

export default function ErrorAlert({ className, error }: ErrorAlertProps) {
	return (
		<Alert className={className} severity="error" icon={<Icon icon="alert-circle" />}>
			<AlertTitle>ERROR {error.status || error.type}</AlertTitle>
			<Typography>{error.data?.type && <strong>{error.data.type}: </strong>}</Typography>
			<Typography>{error.data.message || error.message}</Typography>
			{import.meta.env.DEV && !!error.data?.stack && (
				<pre>
					<Typography className="overflow-x-scroll">{error.data.stack}</Typography>
				</pre>
			)}
		</Alert>
	);
}
